import { useMutation, useQueryCache } from 'react-query';
import { addZones } from 'src/services/api/users';

function useAddZones() {
  const queryCache = useQueryCache();

  return useMutation(({ user, data }) => addZones(user, data), {
    onSuccess: (data) => queryCache.setQueryData(['user', data.data?.id], data),
  });
}

export default useAddZones;
